/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.AccountVerificationResponse, (requestParams: vp.AccountVerificationRequest) => void, () => void];

function useFetchAccountVerification({ api }: HookProps): ReturnTuple {
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.AccountVerificationRequest>();
  const [response, setResponse] = useState<vp.AccountVerificationResponse>({
    ErrorMessage: '',
    Success: false,
    VerificationRequests: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AccountVerificationRequest) => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');
      const res = await api.fetchAccountVerification(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AccountVerificationRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        VerificationRequests: {},
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchAccountVerification);
